var _path, _g, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2748_29001",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00049 2H21.9601V21.9498H2.00049V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2748_29001)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.65049 3.5C5.12949 3.5 3.50049 5.227 3.50049 7.899V16.051C3.50049 18.724 5.12949 20.45 7.65049 20.45H16.3005C18.8275 20.45 20.4605 18.724 20.4605 16.051V7.899C20.4605 5.227 18.8275 3.5 16.3005 3.5H7.65049ZM16.3005 21.95H7.65049C4.27049 21.95 2.00049 19.579 2.00049 16.051V7.899C2.00049 4.371 4.27049 2 7.65049 2H16.3005C19.6855 2 21.9605 4.371 21.9605 7.899V16.051C21.9605 19.579 19.6855 21.95 16.3005 21.95Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.2815 17.1804C5.0955 17.1804 4.9105 17.1124 4.7655 16.9744C4.4645 16.6904 4.4525 16.2144 4.7375 15.9154L6.2655 14.3024C7.0745 13.4434 8.4395 13.4014 9.3025 14.2114L10.2605 15.1834C10.5275 15.4534 10.9615 15.4584 11.2295 15.1944C11.3305 15.0754 13.5085 12.4304 13.5085 12.4304C13.9225 11.9284 14.5065 11.6184 15.1555 11.5544C15.8055 11.4974 16.4365 11.6864 16.9395 12.0994C16.9825 12.1344 17.0215 12.1684 19.2175 14.4234C19.5065 14.7194 19.5015 15.1944 19.2045 15.4834C18.9085 15.7744 18.4325 15.7654 18.1435 15.4694C18.1435 15.4694 16.0945 13.3664 15.9485 13.2244C15.7935 13.0974 15.5445 13.0234 15.2995 13.0474C15.0505 13.0724 14.8265 13.1914 14.6675 13.3844C12.3435 16.2034 12.3155 16.2304 12.2775 16.2674C11.4195 17.1094 10.0345 17.0954 9.1915 16.2354C9.1915 16.2354 8.2615 15.2914 8.2455 15.2724C8.0145 15.0584 7.6025 15.0724 7.3555 15.3334L5.8255 16.9464C5.6775 17.1024 5.4795 17.1804 5.2815 17.1804Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.55769 8.12891C8.00469 8.12891 7.55469 8.57891 7.55469 9.13291C7.55469 9.68691 8.00469 10.1379 8.55869 10.1379C9.11269 10.1379 9.56369 9.68691 9.56369 9.13291C9.56369 8.57991 9.11269 8.12991 8.55769 8.12891ZM8.55869 11.6379C7.17769 11.6379 6.05469 10.5139 6.05469 9.13291C6.05469 7.75191 7.17769 6.62891 8.55869 6.62891C9.94069 6.62991 11.0637 7.75391 11.0637 9.13291C11.0637 10.5139 9.93969 11.6379 8.55869 11.6379Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon);
export default __webpack_public_path__ + "static/media/image_icon.4bd6d8e50df57691393a9beef2e35411.svg";
export { ForwardRef as ReactComponent };